import { BrowserRouter, Route, Routes, useLocation, Navigate } from "react-router-dom";
import { useEffect } from "react";
import SiteHeader from "./components/SiteHeader";
import Footer from "./components/Footer";
import TicketsOverlay from "./components/TicketsOverlay";
import { TicketsProvider } from "./context/TicketsContext";
import Home from "./pages/Home";
import About from "./pages/About";
import Lineup from "./pages/Lineup";
import Participate from "./pages/Participate";
import VenueInfo from "./pages/VenueInfo";
import Faq from "./pages/Faq";
import Sfma from "./pages/Sfma";
import Press from "./pages/Press";
import Contact from "./pages/Contact";
import PreviousLineups from "./pages/PreviousLineups";
import Vending from "./pages/Vending";
import Sponsors from "./pages/Sponsors";
import GetInvolved from "./pages/GetInvolved";

// Reset scroll on route change. Without this, navigating from a long
// page (Lineup) into a short one (Contact) inherits the prior scroll
// position and lands the visitor halfway down the new page.
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}

function Shell() {
  return (
    <>
      <ScrollToTop />
      <SiteHeader />
      <main className="app-main">
        <TicketsOverlay />
        <Routes>
          <Route path="/" element={<Home />} />

          <Route path="/about" element={<About />} />
          <Route path="/about/venue" element={<VenueInfo />} />
          <Route path="/about/faq" element={<Faq />} />
          <Route path="/about/sfma" element={<Sfma />} />
          <Route path="/about/press" element={<Press />} />
          <Route path="/about/contact" element={<Contact />} />

          <Route path="/lineup" element={<Lineup />} />
          <Route path="/lineup/previous" element={<PreviousLineups />} />

          <Route path="/participate" element={<Participate />} />
          <Route path="/participate/vending" element={<Vending />} />
          <Route path="/participate/sponsors" element={<Sponsors />} />
          <Route path="/participate/get-involved" element={<GetInvolved />} />

          {/* Legacy WordPress URLs from rhythmsontherio.com — keep them
              alive so press links and bookmarks don't 404. */}
          <Route path="/venue-info" element={<Navigate to="/about/venue" replace />} />
          <Route path="/faq" element={<Navigate to="/about/faq" replace />} />
          <Route path="/sfma" element={<Navigate to="/about/sfma" replace />} />
          <Route path="/press" element={<Navigate to="/about/press" replace />} />
          <Route path="/contact" element={<Navigate to="/about/contact" replace />} />
          <Route path="/previous-lineups" element={<Navigate to="/lineup/previous" replace />} />
          <Route path="/vending" element={<Navigate to="/participate/vending" replace />} />
          <Route path="/sponsors" element={<Navigate to="/participate/sponsors" replace />} />
          <Route path="/get-involved" element={<Navigate to="/participate/get-involved" replace />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <TicketsProvider>
        <Shell />
      </TicketsProvider>
    </BrowserRouter>
  );
}
